import { Box, Flex, Text } from '@chakra-ui/react';

import {
  formatDateAndTime,
  formatNumber,
  getTitleCase,
} from '../../../../../helpers/utilityFunctions';
import { IPendingTransactionForApproval } from '../../../../../types/pendingTransaction';

interface TransactionDetailsProps {
  transaction: IPendingTransactionForApproval;
}

export default function TransactionDetails({
  transaction,
}: TransactionDetailsProps) {
  const transactionAmountInNaira = transaction?.transactionAmount
    ? transaction.transactionAmount / 100
    : 0;

  const isBillPayment = transaction?.transactionType === 'bill-payment';

  return (
    <>
      <Text fontSize=".875rem" lineHeight="171.429%" mb={2}>
        Amount
      </Text>
      <Flex
        color="#000"
        fontSize="1.125rem"
        lineHeight="144%"
        textAlign="center"
        alignItems="baseline"
        gap={0.5}
      >
        <Text>₦</Text>
        <Text fontSize={{ base: '1.375rem', lg: '1.75rem' }} lineHeight="132%">
          {formatNumber(transactionAmountInNaira).truncatedFormattedString}
        </Text>
        <Text>.{formatNumber(transactionAmountInNaira).koboValue}</Text>
      </Flex>

      <Box py="8" display="flex" flexDirection="column" gap={4} mb={3}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Text color="gray.300" fontSize=".875rem">
            {isBillPayment ? 'Biller ID' : 'Recipient'}
          </Text>
          <Text fontWeight={500} fontSize=".875rem">
            {isBillPayment
              ? transaction?.recipient?.billerId
              : getTitleCase(transaction?.recipient?.accountName ?? 'N/A')}
          </Text>
        </Box>

        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Text color="gray.300" fontSize=".875rem">
            {isBillPayment ? 'Provider' : 'Bank'}
          </Text>
          <Text fontWeight={500} fontSize=".875rem">
            {isBillPayment
              ? transaction?.provider
              : getTitleCase(transaction?.recipient?.bankName ?? 'N/A')}
          </Text>
        </Box>

        {!isBillPayment && (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text color="gray.300" fontSize=".875rem">
              Account Number
            </Text>
            <Text fontWeight={500} fontSize=".875rem">
              {transaction?.recipient?.accountNumber ?? 'N/A'}
            </Text>
          </Box>
        )}

        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Text color="gray.300" fontSize=".875rem">
            Status
          </Text>
          <Text
            fontWeight={500}
            fontSize=".875rem"
            color={transaction?.status === 'pending' ? '#C78F1E' : 'gray.500'}
          >
            {getTitleCase(transaction?.status ?? '')}
          </Text>
        </Box>
      </Box>

      <Box
        p={8}
        borderRadius="24px"
        background="#fafafa"
        border="1px solid #ebedef"
      >
        <Text fontSize=".875rem" fontWeight={500} lineHeight="142.857%" mb={4}>
          Other Information
        </Text>

        <Box display="flex" flexDirection="column" gap={4} mb={3}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text color="gray.300" fontSize=".875rem">
              Transaction Type
            </Text>
            <Text fontWeight={500} fontSize=".875rem">
              {getTitleCase(transaction?.transactionType ?? '')}
            </Text>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text color="gray.300" fontSize=".875rem">
              Initiator
            </Text>
            <Text fontWeight={500} fontSize=".875rem">
              {transaction?.initiatedBy?.user?.firstName +
                ' ' +
                transaction?.initiatedBy?.user?.lastName}
            </Text>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text color="gray.300" fontSize=".875rem">
              Date Initiated
            </Text>
            <Text fontWeight={500} fontSize=".875rem">
              {formatDateAndTime(transaction?.initiatedAt ?? '')}
            </Text>
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text color="gray.300" fontSize=".875rem">
              Outlet
            </Text>
            <Text fontWeight={500} fontSize=".875rem">
              {getTitleCase(transaction?.outlet?.name ?? 'N/A')}
            </Text>
          </Box>
        </Box>
      </Box>
    </>
  );
}
